import { useEffect, useState, useRef } from 'react';
import { ClickAwayListener } from '@mui/material';

import DateRangeSelection from '../../global/DateRangeSelection';

const formatDateToLongLabel = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  const month = date.toLocaleString('en-US', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
};

const getDisplayString = (dueDateValues, dueStartDateValue, dueEndDateValue) => {
  if (dueDateValues.length) return dueDateValues[0].label;
  let str = '';
  if (dueStartDateValue.length) str += formatDateToLongLabel(dueStartDateValue[0]._id);
  if (dueEndDateValue.length) str += ' - ' + formatDateToLongLabel(dueEndDateValue[0]._id);
  return str;
};

const DueDatePill = ({ dueDate, dueDateOptions, dueEndDate, dueStartDate, onRemove, onValueSelection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  const handleMenuToggle = () => {
    if (!isMenuOpen && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setMenuPos({ top: rect.bottom + 6, left: rect.left });
    }
    setIsMenuOpen((prev) => !prev);
  };

  const isOptionChecked = (item) => dueDate?.some((v) => v._id === item._id);

  const handleClickAway = () => {
    if (!isMenuOpen) return;
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (dueDate?.length === 0 && dueStartDate?.length === 0 && dueEndDate?.length === 0) {
      setIsMenuOpen(false);
    }
  }, [dueDate, dueStartDate, dueEndDate]);

  if (dueDate?.length === 0 && dueStartDate?.length === 0 && dueEndDate?.length === 0) return null;

  const displayString = getDisplayString(dueDate, dueStartDate, dueEndDate);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className="relative" ref={wrapperRef}>
        <li
          className="relative m-1 bg-white inline-flex items-center justify-center text-[12px] font-medium leading-5 rounded-full px-4 py-1 border border-slate-300 shadow-sm duration-150 ease-in-out cursor-pointer"
          onClick={handleMenuToggle}
        >
          <div className="h-5 flex gap-1 items-center">
            <div>Due Date is </div>
            <div>{displayString}</div>
          </div>
          <img onClick={onRemove} className="text-slate-700 h-5 w-2 ml-2" src="/images/icons/close.svg" style={{ cursor: 'pointer' }} alt="icon" />
        </li>
        {isMenuOpen && (
          <DateRangeSelection
            dueDate={dueDate}
            dueDateOptions={dueDateOptions}
            dueEndDate={dueEndDate}
            dueStartDate={dueStartDate}
            isOptionChecked={isOptionChecked}
            onValueSelection={onValueSelection}
            menuStyle={{ top: menuPos.top, left: menuPos.left }}
          />
        )}
      </div>
    </ClickAwayListener>
  );
};

export default DueDatePill;
